import React from 'react';
import { kebabCase, get } from 'lodash';
import {
  Accordion,
  AccordionContent,
  AccordionGroup,
  AccordionHeader,
} from 'core/controls/accordion/Accordion';
import CompareRow from '../compareRow/CompareRow';
import { combineClassNames } from '../../../../core/css';
import { useTranslate } from '../../../../core/translate';

const CompareTable = ({
  columns,
  columnOptions,
  staticTable,
  compareGroupList,
  onFeatureModalOpen,
  defaultSection,
  analyticsKey,
  headers,
  searchFeature,
  openSearchFeatureAccordion,
  onOpenSearchFeatureAccordion,
  scrollToSearchFeature,
  onScrollToSearchFeature,
}) => {
  // (Took from 2.0)
  // Map through Compare group keys.
  const translate = useTranslate();
  const list = compareGroupList.map(({ groupKey, group }) => {
    // Map through each feature group key (RPO or Other identifier for Warranty)
    const features = group.reduce((accum, { featureKey, feature }) => {
      const featureValues = columns.map(({ groups }) =>
        get(groups, [groupKey, featureKey])
      );
      if (featureValues.some((val) => val !== null && val !== undefined)) {
        const values = columnOptions.map((columnOption) => {
          return {
            columnOption,
            features: featureValues,
          };
        });

        return [
          ...accum,
          {
            id: featureKey,
            ...feature,
            values,
          },
        ];
      }
      return accum;
    }, []);

    return {
      id: kebabCase(groupKey),
      description: groupKey,
      features,
    };
  });

  const accessibleHeader = (
    <thead>
      <tr className="visually-hidden" role="row">
        <th role="columnheader"></th>
        <>
          {columnOptions.map((opt, i) => (
            <th role="columnheader" aria-sort="none" key={i} scope="col">
              {headers[opt.activeIndex]?.primaryText}
            </th>
          ))}
        </>
      </tr>
    </thead>
  );

  // TODO: Performance updates. Table performs poorly when there are too many rows.
  return (
    <div className="compare-table">
      <Accordion>
        {list.length > 0 &&
          list.map(({ id, description, features }, i) => {
            return (
              <AccordionGroup
                key={id}
                id={id}
                isOpenDefault={
                  defaultSection ? description === defaultSection : i === 0
                }
                displayOnly={list.length === 1}
                className="compare__accordion-item">
                <AccordionHeader
                  alignButtonLeft
                  ariaLabel={translate('compare.accordion.title.aria.v3', {
                    description,
                  })}
                  expandIcon="expand"
                  collapseIcon="collapse"
                  className={combineClassNames(
                    'compare__accordion-title',
                    'stat-expand-icon'
                  )}
                  analyticsKey={analyticsKey}
                  open={
                    openSearchFeatureAccordion &&
                    searchFeature.group == description
                  }
                  onOpen={onOpenSearchFeatureAccordion}>
                  {description}
                </AccordionHeader>
                <AccordionContent className="compare__accordion-content">
                  <table
                    aria-rowcount={features.length - 1}
                    aria-label={translate('compare.accordion.table.aria.v3', {
                      description,
                    })}
                    className="table-reset">
                    {accessibleHeader}
                    <tbody className="table-reset">
                      {features.map((feature, i) => (
                        <CompareRow
                          className={combineClassNames(
                            i % 2 == 0
                              ? 'compare-row--even'
                              : 'compare-row--odd',
                            description === searchFeature.group &&
                              feature.id === searchFeature.feature
                              ? 'compare-row--highlighted'
                              : ''
                          )}
                          rowIndex={i}
                          feature={feature}
                          key={feature.id}
                          disclosure={feature.disclosure}
                          onFeatureModalOpen={onFeatureModalOpen}
                          staticTable={staticTable}
                          analyticsKey={analyticsKey}
                          scroll={
                            searchFeature.group === description &&
                            searchFeature.feature === feature.id &&
                            scrollToSearchFeature
                          }
                          onScroll={onScrollToSearchFeature}
                        />
                      ))}
                    </tbody>
                  </table>
                </AccordionContent>
              </AccordionGroup>
            );
          })}
      </Accordion>
    </div>
  );
};

export default CompareTable;
